import { observable, makeObservable } from "mobx";
class MerchantStore {
  UserInfo: any = { role_id: 0 };

  constructor() {
    makeObservable(this, {
      UserInfo: observable,
    });
    this.setUserInfo = this.setUserInfo.bind(this);
  }
  setData(data: any) {
    this.UserInfo = data;
  }

  // 设置信息
  async setUserInfo(data: any) {
    this.setData(data);
  }
}

export default MerchantStore;
